<template>
  <td :colspan="headers.length" class="content pl-13 pb-10">
    <v-card class="rounded-b-lg" outlined>
      <v-data-table
        :items="customers"
        :headers="pendingInvoiceHeaders"
        item-key="index"
        hide-default-footer
        single-expand
        disable-sort
        show-expand
      >
        <template v-slot:item.host_total="{ item }">
          {{ formatMoney(item.host_total) }}
        </template>
        <template v-slot:item.customer="{ item }">
          {{ document(item.customer) }}
        </template>
        <template v-slot:[`expanded-item`]="{ headers, item }">
          <PaymentListPending :headers="headers" :payments="item.payments_invoices" />
        </template>
      </v-data-table>
    </v-card>
  </td>
</template>

<script>
import { catalogMonetary } from '@/util/catalog'
import { pendingInvoiceHeaders } from '../../adminInvoiceHeaders'
import { formatDocument } from '@/util/document'

import PaymentListPending from './PaymentListPending'

export default {
  name: 'CustomerListPending',

  components: {
    PaymentListPending,
  },

  props: {
    headers: {
      type: Array,
      required: true,
    },

    customers: {
      type: Array,
      required: false,
    },
  },

  methods: {
    formatMoney(value) {
      return catalogMonetary(value)
    },

    document(customer) {
      if (!customer) return '---'
      return formatDocument(customer.cnpj)
    },
  },

  data() {
    return {
      pendingInvoiceHeaders,
      formatDocument,
    }
  }
}
</script>
